import { makeStyles, createStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) =>
  createStyles({
    bannerWrap: {
      marginTop: theme.spacing(4),
      padding: theme.spacing(0, 2),
      [theme.breakpoints.up('md')]: {
        paddingBottom: theme.themeName === 'dacia' ? theme.spacing(2) : theme.spacing(0)
      }
    },
    bannerHeadline: {
      marginBottom: theme.themeName === 'dacia' ? theme.spacing(2) : theme.spacing(3),
      [theme.breakpoints.up('md')]: {
        marginBottom: theme.themeName === 'dacia' ? theme.spacing(4) : theme.spacing(3)
      }
    }
  })
);
